<template>
    <div class="main-sidebar">
        <div @click="changeUrl('/')" class="title-sidebar">
            <img src="../../assets/images/giverise-logo-white.svg" alt="new-logo" class="sidebar-logo" />
        </div>
        <div class="sidebar-content">
            <div class="input-search">
                <img src="../../assets/images/search.svg" alt="" />
                <input v-model="search" type="text" placeholder="Search..." @input="debounceInput" />
            </div>
            <div class="sidebar-menu">
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.DASHBOARD)" @click="changeUrl('/dashboard')" class="menu"
                    :class="{ 'menu-active': $route.path === '/dashboard' }">
                    <p>Dashboard</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.CAMPAIGN_LIST)" @click="changeUrl('/campaigns')"
                    class="menu" :class="{ 'menu-active': $route.path === '/campaigns' }">
                    <p>Campaigns</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.DONATION_LIST)" @click="changeUrl('/donations')"
                    class="menu" :class="{ 'menu-active': $route.path === '/donations' }">
                    <p>Donations</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.SUPPORTERS_LIST)" @click="changeUrl('/supporters')"
                    class="menu" :class="{ 'menu-active': $route.path === '/supporters' }">
                    <p>Supporters</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.DESIGNATION_LIST)" @click="changeUrl('/designations')" class="menu"
                    :class="{ 'menu-active': $route.path === '/designations' }">
                    <p>Designations</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.WIDGET_MANAGEMENT)" @click="changeUrl('/widgets')" class="menu" :class="{ 'menu-active': $route.path === '/widgets' }">
                    <p>Widgets</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.USER_MANAGEMENT)" @click="changeUrl('/users')" class="menu" :class="{ 'menu-active': $route.path === '/users' }">
                    <p>Users</p>
                </div>
                <div v-if="DibbleJS.isAllowedAccess(MODULE_NAMES.ACCOUNT)" @click="changeUrl('/account')" class="menu" :class="{ 'menu-active': $route.path === '/account' }">
                    <p>Account</p>
                </div>
                <div v-for="(menu, index) in listMenu" :key="index">
                    <div @click="changeUrl(menu.url)" class="menu" :class="{
                        'menu-active':
                            $route.path === menu.url ||
                            ($route.name &&
                                menu.otherIncludeRouteName.length &&
                                menu.otherIncludeRouteName.includes(
                                    $route.name
                                )),
                    }">
                        <p>{{ menu.label }}</p>
                        <button v-if="menu.label === 'Rental' &&
                            $route.path.includes('rental-order')
                            " @click="changeStatusShowSubmenu" :class="{ 'button-active': showSubmenu }">
                            <img src="../../assets/images/Vector.svg" alt="" />
                        </button>
                    </div>
                    <transition name="expand" v-if="menu.label === 'Rental' &&
                        $route.path.includes('rental-order')
                        ">
                        <div class="sub-menu" v-if="menu.label === 'Rental' &&
                            $route.path.includes('rental-order') &&
                            showSubmenu
                            ">
                            <div @click="
                                changeUrl(
                                    `/rental-order/${currentViewOrderId}/info`
                                )
                                " class="menu menu-active">
                                <p :class="{
                                    'text-white': !(
                                        $route.path.includes(
                                            'rental-order'
                                        ) && $route.path.includes('info')
                                    ),
                                }">
                                    Order & User Info
                                </p>
                            </div>
                            <div @click="
                                changeUrl(
                                    `/rental-order/${currentViewOrderId}/reservation`
                                )
                                " class="menu menu-active">
                                <p :class="{
                                    'text-white': !(
                                        $route.path.includes(
                                            'rental-order'
                                        ) &&
                                        $route.path.includes('reservation')
                                    ),
                                }">
                                    Check in & Return
                                </p>
                            </div>
                            <div @click="
                                changeUrl(
                                    `/rental-order/${currentViewOrderId}/payments`
                                )
                                " class="menu menu-active">
                                <p :class="{
                                    'text-white': !(
                                        $route.path.includes(
                                            'rental-order'
                                        ) &&
                                        $route.path.includes('payments')
                                    ),
                                }">
                                    Payments
                                </p>
                            </div>
                            <div @click="
                                changeUrl(
                                    `/rental-order/${currentViewOrderId}/notes`
                                )
                                " class="menu menu-active">
                                <p :class="{
                                    'text-white': !(
                                        $route.path.includes(
                                            'rental-order'
                                        ) && $route.path.includes('notes')
                                    ),
                                }">
                                    Notes
                                </p>
                            </div>
                            <div @click="
                                changeUrl(
                                    `/rental-order/${currentViewOrderId}/files`
                                )
                                " class="menu menu-active">
                                <p :class="{
                                    'text-white': !(
                                        $route.path.includes(
                                            'rental-order'
                                        ) && $route.path.includes('files')
                                    ),
                                }">
                                    Files
                                </p>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserMenuRoleModuleAssignment from '../../utils/UserMenuRoleAssignments';
import Authorizations from '../../utils/authorizations';
import { EventBus } from '@/utils/event-bus';
import _ from 'lodash';
import DibbleApi from '@/api';
import DibbleJS from '@/dibble';
export default {
    name: 'NewSideBar',
    data() {
        return {
            MODULE_NAMES: Authorizations.MODULE_NAMES,
            DibbleJS,
            showSubmenu: true,
            listMenu: [],
            currentViewOrderId: '',
            search: '',
            searchTimeout: null,
            currentRouteName: this.$route.name || '',
            rentalRouteNames: [
                'Dashboard',
                'Rental',
                'BoatTypeInfo',
                'RentalMap',
                'RentalOrderHistory',
                'RentalHistory',
                'RentalOrderInfo',
                'RentalOrderReservation',
                'RentalOrderPayments',
                'RentalOrderNotes',
                'RentalOrderFiles',
            ],
            moorageRouteNames: [
                'Moorage',
                'MoorageOrder',
                'MoorageSlips',
                'MoorageMap',
                'MoorageOrderTable',
                'MoorageOrder',
                'NoRentalDays',
            ],
            appUserRouteNames: ['AppUsersList'],
        };
    },
    mounted() {
        const userAuth = this.$cookies.get('_user');
        this.listMenu = UserMenuRoleModuleAssignment.getNavItemsAssignments(
            userAuth.role
        );
    },
    computed: {
        isRentalRoute() {
            return this.rentalRouteNames.includes(this.currentRouteName);
        },
        isMoorageRoute() {
            return this.moorageRouteNames.includes(this.currentRouteName);
        },
        isAppUserRoute() {
            return this.appUserRouteNames.includes(this.currentRouteName);
        },
    },
    watch: {
        $route(to) {
            this.currentRouteName = to.name;
        },
    },
    created() {
        EventBus.$on('currentViewOrderId', (orderId) => {
            this.currentViewOrderId = orderId;
        });

        EventBus.$on('clearSidebarSearchBox', () => {
            this.search = '';
        });
    },
    methods: {
        searchCampaigns() {
            DibbleJS.showLoader();
            const params = {
                '#request': DibbleApi.api.getAllCampaign,
                search_string: this.search,
            };
            DibbleJS.callApiRequest(params, (response) => {
                DibbleJS.hideLoader();
                if (response.rc === 0) {
                    const { campaigns } = response;
                    if (campaigns.length) {
                        if (campaigns.length === 1) {
                            this.$router.push({
                                name: 'CampaignsView',
                                params: {
                                    id: campaigns[0].campaign_id,
                                },
                            });
                        } else {
                            if (this.$router.currentRoute.path !== '/campaigns')
                                this.$router.push(
                                    `/campaigns?q=${this.search}`
                                );
                            else EventBus.$emit('searchCampaigns', this.search);
                        }
                    } else {
                        DibbleJS.toastErrorMessage(
                            'There is no record matched your query.'
                        );
                    }
                }
            });
        },
        debounceInput: _.debounce(function (e) {
            this.search = e.target.value;

            if (this.$route.name === 'CampaignDonations') {
                return EventBus.$emit('searchDonations', this.search);
            }

            if (this.$route.name === 'Designations') {
                return EventBus.$emit('searchDesignations', this.search);
            }

            if (this.$route.name === 'DesignationDonations') {
                return EventBus.$emit('searchDesignationDonations', this.search);
            }

            if (this.$route.name === 'Widgets' || this.$route.name === 'Widgets Archive') {
                return EventBus.$emit('searchWidgets', this.search);
            }

            if (this.$route.name === 'DonationsList') {
                return EventBus.$emit('searchDonations', this.search);
            }

            if (this.$route.name === 'SupportersList') {
                return EventBus.$emit('searchSupporters', this.search);
            }

            this.searchCampaigns();
        }, 1500),
        changeStatusShowSubmenu(e) {
            e.stopPropagation();
            this.showSubmenu = !this.showSubmenu;
        },
        changeUrl(url) {
            this.search = '';
            if (this.$route.name === 'CampaignsListView') {
                EventBus.$emit('searchCampaigns', this.search);
            }

            this.$router.push(url).catch((err) => err);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-sidebar {
    width: 100%;
    height: 100vh;
    background: linear-gradient(180deg, #19649f 36.98%, #24bbda 100%);
    border-radius: 0px 50px 50px 0px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .sidebar-content {
        height: 100%;
        box-shadow: 0px 24px 17px 10px #b6b6b6;
        background: transparent;
        border-bottom-right-radius: 50px;
    }
}

.title-sidebar {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1.5px solid #2278aa;
    cursor: pointer;
    user-select: none;
    width: 100%;
}

.input-search {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 10px;
    width: 85%;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 10px 20px;
    gap: 10px;
    background: #f5f5f5;
    border-radius: 100px;
    user-select: none;

    input {
        border: none !important;
        background: #f5f5f5;
        font-family: 'Open Sans';
        font-style: normal;
        font-size: 16px;
        width: 80%;
    }
}

input::placeholder {
    opacity: 1;
    color: #7c7c7a;
    font-weight: 500;
}

.sidebar-logo {
    width: 180px;
}

.sidebar-menu {
    margin-top: 20px;
    width: 100%;
    flex: 1;
    overflow: auto;
    min-height: 0;
    transition: all 0.4s;

    .menu {
        height: 65px;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: space-between;

        p {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            letter-spacing: 0.04em;
            color: #fff;
            padding-left: 25px;
            user-select: none;
        }

        &:hover {
            background: rgba(44, 148, 171, 0.3);

            p {
                color: #52b9d0;
            }
        }

        button {
            outline: none;
            background: none;
            border: none;
            margin-right: 20px;
            border-radius: 100%;
            background: #4e6876;
            line-height: 24px;
            user-select: none;
            transition: all 0.4s;

            img {
                transition: all 0.4s;
            }
        }

        .button-active {
            background: #52b9d0;

            img {
                transform: rotate(180deg);
            }
        }
    }

    .menu-active {
        background: rgba(44, 148, 171, 0.3);

        p {
            color: #52b9d0;
        }
    }

    .expand-enter-active,
    .expand-leave-active {
        transition: all 0.4s ease;
        max-height: 400px;
    }

    .expand-enter,
    .expand-leave-to {
        max-height: 0;
        overflow: hidden;
    }
}
</style>
